import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/calculator/page.tsx");
